// Geometry and motion of the You spinner, kept in a plain module (no JSX, no
// styled-components) so anything that has to REDRAW the spinner outside React
// can read the same numbers instead of copying them. Today that is the pre-app
// splash inlined in each app's index.html, which paints before any bundle
// exists — see apps/you/CLAUDE.md (IDCASH-213).
export const YOU_SPINNER_TOKENS = Object.freeze({
  OUTER_COLOR: '#C4C4C4',
  INNER_COLOR: '#AAAAAA',
  INNER_SCALE: 0.75,
  SPIN_MS: 3000,
  CYCLE_MS: 2500,
  VIEWBOX: 100,
  RADIUS: 44,
  DEFAULT_THICKNESS: 6,
  DEFAULT_SIZE: '24px',
});

export const YOU_SPINNER_CENTER = YOU_SPINNER_TOKENS.VIEWBOX / 2;

export const YOU_SPINNER_CIRCUMFERENCE =
  2 * Math.PI * YOU_SPINNER_TOKENS.RADIUS;

export default YOU_SPINNER_TOKENS;
